<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <div class="d-flex justify-content-between align-items-center option">
            <span
              ><span class="font-weight-bold">{{ phoneNumber }}</span>
              <b-icon :icon="verifiedIcon" :variant="verifiedVariant"
            /></span>
            <a href="#" @click.prevent="onUpdate">Update your mobile number</a>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <p>
            <small class="font-italic"
              >* Your mobile provider's standard text message rates
              apply.</small
            >
          </p>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "PhoneNumber",
  props: ["phoneNumber", "isVerified"],
  computed: {
    verifiedIcon() {
      return this.isVerified ? "check2" : "x";
    },
    verifiedVariant() {
      return this.isVerified ? "success" : "danger";
    },
  },
  methods: {
    onUpdate() {
      this.$emit("update");
    },
  },
};
</script>
